import React, { Component } from "react";
import { Form, Button, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import {
  PATHS,
  STATUS,
  SORT_BY_ISSUE_FILTER_LIST,
  PROJECT_AWARDED_BY,
  OTHER_CALENDER,
  SORT_BY_FILTERS_LIST
} from "../../constant";
import { get } from "lodash";
import IconFilter from "../../assets/filter-4.png";
import {
  dateFormat,
  formatNumber,
  formatNumberOnDashBoard,
  getLocalstorage,
  isValidArray,
  scrollToPosition,
  transformIssueListPayload
} from "../../helper";
import IssueListWitLoader from "../IssueListWithLoader/IssueListingWithLoader";
import PermissionHOC from "../PermissionHOC";
import Pagination from "../Pagination";
import LoaderTemplate from "../../component/LoaderTemplate";
import { FilterLoader } from "../../component/LoadersTemplate";
import FilterComponent from "../FilterComponent";
import { getIssueStakeHolderAction } from "../../actions/issuesListAction.actions";
import {
  getDownloadIssueListAction,
  getDownloadIssueBriefDocAction,
  getDownloadIssueBriefPDFAction,
  clearIssueListDownloadAction,
  clearIssueBriefDownloadAction,
  clearIssueBriefPdfDownloadAction
} from "../../actions/dowloadExcelActions";

import { SendByComponent } from "../sendNotification";
import DisplayByPermission from "../../component/DisplayByPermission";
import { DownloadExcelReport, Search, SortBy } from "../reusableComponent";
import {
  _getIssueList,
  CLEAR_ISSUE_OLD_FILTERS_ACTION
} from "../../actions/issues.action";
import { IssueListHoc } from "./issueListHOC";
import CalendarFilter from "../calendarFilter/CalendarFilter";
import { ToggleBtn } from "../togglebtn";
import {
  getDashboardNotifications,
  getDashboardNotificationsAllViewed,
  getNotificationUpdates
} from "../../actions/dashboard.action";
import { getProjectTimelineData } from "../../actions/projectDetail.action";
import queryString from "query-string";
import ResponsiveFilter from "../FilterComponent/ResponsiveFilter";
import FilterIcon from "../../assets/filter-icon.png";
import { ModalIIGCreateProjectDisabled } from "../createProject/ModalIIGCreateProjectDisabled";
import IssueQuickFilter from "../FilterComponent/IssueQuickFilter";
import { getissueListParams } from "../../services/apiServices";
import request from "../../services/requestService";
import StateIssuesQuickFilter from "../FilterComponent/StateIssuesQuickFilter";

class IssueList extends Component {
  constructor(props) {
    super(props);
    const {
      location: { isDashBoard, summaryDataBy }
    } = props;

    const userSponsoredScheme = getLocalstorage("userSponsoredScheme");
    const summaryType = getLocalstorage("summaryType");
    const user = getLocalstorage("user");
    let _projectAwardedBy =
      user.groupCategory === "STATE_PMG"
        ? user.sponsoredScheme === "STATE" || summaryType === "SPONSOR"
        : isDashBoard
        ? isDashBoard && summaryDataBy
        : userSponsoredScheme;

    const isUserGroupCategory =
      user.groupCategory === "DISTRICT" ||
      user.groupCategory === "STATE_DEPARTMENT";
    let _projectAwardedByDashboard =
      isDashBoard !== undefined &&
      getLocalstorage("stateAndCentralProjectSelectedBy") === "STATE" &&
      isUserGroupCategory;

    this.state = {
      paginationNo: "",
      selectedEle: "",
      //projectAwardedBy: _projectAwardedBy || _projectAwardedByDashboard,
      projectAwardedBy: false,
      displayDateTitle: " - Created Date -",
      showModalForCreateProjectDisabled: false,
      quickfilterdatanew: [
        "projectFlags",
        "recipientState",
        "recipientCenter",
        "centerState",
        "stages",
        "category",
        "sponsoringMinistry",
        "projectStatus",
        "projectStage",
        "issueZones"
      ],
      Monitoringflagcurrent: [],
      ProjectStatuscurrent: [],
      ProjectStagecurrent: [],
      RecipientStatecurrent: [],
      RecipientMinistrycurrent: [],
      IssueLocationcurrent: [],
      IssueZonecurrent: [],
      IssueStagescurrent: [],
      IssueCategorycurrent: [],
      IssueSponsoringMinistrycurrent: [],
      staticfilterdata: [],
      static_payload: {
        offset: 0,
        limit: 1,
        groupCategory: "CENTRAL",
        projectCost: [],
        delayedProject: [],
        costOverRun: [],
        issueAgeing: []
      },
      static_payload_for_state: {
        offset: 0,
        limit: 1,
        groupCategory: "STATE",
        projectCost: [],
        delayedProject: [],
        costOverRun: [],
        issueAgeing: []
      },
      staticfilterdata_for_state: [],
      QuickFilters: [],
      StateQuickFilters: [],
      MonitoringFlag_State: [],
      RecipientDistrict_State: [],
      Recipient_State_Department: [],
      IssueStages_State: [],
      Issue_Category_State: [],
      Issue_Sponsoring_Department: [],
      ProjectStatus_State: [],
      ProjectStage_State: [],
      quickfilterdatastate: [
        "projectFlags",
        "recipientDistrict",
        "recipientStateDepartment",
        "stages",
        "category",
        "sponsoringDepartment",
        "projectStatus",
        "projectStage"
      ]
    };
  }
  handleStateFilterChange = async (updatedFilters, filterName) => {
    if (filterName == undefined) {
      // remove duplicates from updatedFilters
      const uniqueData = Array.from(
        new Map(updatedFilters.map(item => [item.id, item])).values()
      );

      this.setState({ StateQuickFilters: uniqueData }, () => {
        //console.log(this.state.StateQuickFilters);
      });
    } else {
      const updatedData = updatedFilters.map(obj => ({
        ...obj,
        filterName: filterName
      }));

      const mergedData = [...this.state.StateQuickFilters, ...updatedData];

      const uniqueData = Array.from(
        new Map(mergedData.map(item => [item.id, item])).values()
      );

      this.setState({ StateQuickFilters: uniqueData }, () => {
        //console.log(this.state.StateQuickFilters);
      });
    }
  };

  // handleStateFilterChange = async (updatedFilters, filterName) => {
  //   if (filterName == undefined) {
  //     const newData = [];
  //     newData.push(...updatedFilters);
  //     this.setState({ StateQuickFilters: newData }, () => {
  //       //console.log(this.state.QuickFilters)
  //     });
  //   } else {
  //     const updatedData = updatedFilters.map(obj => ({
  //       ...obj,
  //       filterName: filterName
  //     }));
  //     const newData = [...this.state.StateQuickFilters];
  //     newData.push(...updatedData);
  //     this.setState({ StateQuickFilters: newData }, () => {
  //       //console.log(this.state.QuickFilters);
  //     });
  //   }
  //   const response = await request(
  //     getissueListParams(
  //       transformIssueListPayload(this.state.static_payload_for_state)
  //     )
  //   );
  //   this.setState({ staticfilterdata_for_state: response.data.data.filters });
  // };
  handleFilterChange = async (updatedFilters, filterName) => {
    if (filterName == undefined) {
      const newData = [];
      newData.push(...updatedFilters);
      this.setState({ QuickFilters: newData }, () => {
        console.log(this.state.QuickFilters);
      });
    } else {
      const updatedData = updatedFilters.map(obj => ({
        ...obj,
        filterName: filterName
      }));
      const newData = [...this.state.QuickFilters];
      newData.push(...updatedData);
      this.setState({ QuickFilters: newData }, () => {
        //console.log(this.state.QuickFilters);
      });
    }
    const response = await request(
      getissueListParams(transformIssueListPayload(this.state.static_payload))
    );
    this.setState({ staticfilterdata: response.data.data.filters });
  };
  componentDidMount = async () => {
    const {
      location: { state, isDashBoard }
    } = this.props;
    if (isDashBoard) {
      let projectAwardedBy = state.groupCategory === "STATE" ? true : false;
      this.setState({
        projectAwardedBy: projectAwardedBy
      });
    }

    //Static issue Filter API Call Starts
    const response = await request(
      getissueListParams(transformIssueListPayload(this.state.static_payload))
    );
    this.setState({ staticfilterdata: response.data.data.filters });

    const state_response = await request(
      getissueListParams(
        transformIssueListPayload(this.state.static_payload_for_state)
      )
    );
    this.setState({
      staticfilterdata_for_state: state_response.data.data.filters
    });
    //Static issue Filter API Call End
  };
  handleChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  onPageChange = data => {
    const {
      _getIssueList,
      issueListReducer: { selectedFilters }
    } = this.props;
    let offset = Math.ceil(data.selected);
    _getIssueList({
      ...selectedFilters,
      offset,
      ...{ groupCategory: this.getGroupCategory() }
    });
    scrollToPosition({ top: 0 });
  };
  handleCheckbox1 = (filter, filterName) => {
    console.log(filter, filterName, this.state.QuickFilters);
    this.setState(
      {
        QuickFilters: this.state.QuickFilters.filter(function(val) {
          return val !== filter;
        })
      },
      () => {
        const filteredDisplayNames1 = this.state.QuickFilters.filter(
          item => item.filterName === "projectFlags"
        ).map(item => item);
        console.log(filteredDisplayNames1);
        this.setState({ Monitoringflagcurrent: filteredDisplayNames1 });
        const filteredDisplayNames2 = this.state.QuickFilters.filter(
          item => item.filterName === "recipientState"
        ).map(item => item);
        this.setState({ RecipientStatecurrent: filteredDisplayNames2 });
        const filteredDisplayNames3 = this.state.QuickFilters.filter(
          item => item.filterName === "recipientCenter"
        ).map(item => item);
        this.setState({ RecipientMinistrycurrent: filteredDisplayNames3 });
        const filteredDisplayNames4 = this.state.QuickFilters.filter(
          item => item.filterName === "centerState"
        ).map(item => item);
        this.setState({ IssueLocationcurrent: filteredDisplayNames4 });
        const filteredDisplayNames5 = this.state.QuickFilters.filter(
          item => item.filterName === "category"
        ).map(item => item);
        this.setState({ IssueCategorycurrent: filteredDisplayNames5 });
        const filteredDisplayNames6 = this.state.QuickFilters.filter(
          item => item.filterName === "sponsoringMinistry"
        ).map(item => item);
        this.setState({
          IssueSponsoringMinistrycurrent: filteredDisplayNames6
        });
        const filteredDisplayNames7 = this.state.QuickFilters.filter(
          item => item.filterName === "projectStatus"
        ).map(item => item);
        this.setState({ ProjectStatuscurrent: filteredDisplayNames7 });
        const filteredDisplayNames8 = this.state.QuickFilters.filter(
          item => item.filterName === "projectStage"
        ).map(item => item);
        this.setState({ ProjectStagecurrent: filteredDisplayNames8 });
        const filteredDisplayNames9 = this.state.QuickFilters.filter(
          item => item.filterName === "stages"
        ).map(item => item);
        this.setState({ IssueStagescurrent: filteredDisplayNames9 });
        const filteredDisplayNames10 = this.state.QuickFilters.filter(
          item => item.filterName === "issueZones"
        ).map(item => item);
        this.setState({ IssueZonecurrent: filteredDisplayNames10 });
        if (filterName == "projectStage") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData9(filter, filterName);
        } else if (filterName == "category") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData6(filter, filterName);
        } else if (filterName == "centerState") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData4(filter, filterName);
        } else if (filterName == "recipientCenter") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData3(filter, filterName);
        } else if (filterName == "projectGroupBy") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData(filter, filterName);
        } else if (filterName == "stages") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData5(filter, filterName);
        } else if (filterName == "recipientState") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData2(filter, filterName);
        } else if (filterName == "projectFlags") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData1(filter, filterName);
        } else if (filterName == "sponsoringMinistry") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData7(filter, filterName);
        } else if (filterName == "projectStatus") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData8(filter, filterName);
        } else if (filterName == "issueZones") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData10(filter, filterName);
        } else {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData(filter, filterName);
        }
      }
    );
  };
  handleStateCheckbox = (filter, filterName) => {
    console.log(filter, filterName, this.state.StateQuickFilters);

    this.setState(
      {
        StateQuickFilters: this.state.StateQuickFilters.filter(function(val) {
          return val !== filter;
        })
      },
      () => {
        const filteredDisplayNames1 = this.state.StateQuickFilters.filter(
          item => item.filterName === "projectFlags"
        ).map(item => item);
        console.log(filteredDisplayNames1);
        this.setState({ MonitoringFlag_State: filteredDisplayNames1 });
        const filteredDisplayNames2 = this.state.StateQuickFilters.filter(
          item => item.filterName === "recipientDistrict"
        ).map(item => item);
        this.setState({ RecipientDistrict_State: filteredDisplayNames2 });
        const filteredDisplayNames3 = this.state.StateQuickFilters.filter(
          item => item.filterName === "recipientStateDepartment"
        ).map(item => item);
        this.setState({ Recipient_State_Department: filteredDisplayNames3 });
        const filteredDisplayNames5 = this.state.StateQuickFilters.filter(
          item => item.filterName === "category"
        ).map(item => item);
        this.setState({ Issue_Category_State: filteredDisplayNames5 });
        const filteredDisplayNames6 = this.state.StateQuickFilters.filter(
          item => item.filterName === "sponsoringDepartment"
        ).map(item => item);
        this.setState({
          Issue_Sponsoring_Department: filteredDisplayNames6
        });
        const filteredDisplayNames7 = this.state.StateQuickFilters.filter(
          item => item.filterName === "projectStatus"
        ).map(item => item);
        this.setState({ ProjectStatus_State: filteredDisplayNames7 });
        const filteredDisplayNames8 = this.state.StateQuickFilters.filter(
          item => item.filterName === "projectStage"
        ).map(item => item);
        this.setState({ ProjectStage_State: filteredDisplayNames8 });
        const filteredDisplayNames9 = this.state.StateQuickFilters.filter(
          item => item.filterName === "stages"
        ).map(item => item);
        this.setState({ IssueStages_State: filteredDisplayNames9 });
        if (filterName == "projectStage") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData8_State(filter, filterName);
        } else if (filterName == "category") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData5_State(filter, filterName);
        } else if (filterName == "recipientDistrict") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData2_State(filter, filterName);
        } else if (filterName == "recipientStateDepartment") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData3_State(filter, filterName);
        } else if (filterName == "projectGroupBy") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData(filter, filterName);
        } else if (filterName == "stages") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData4_State(filter, filterName);
        } else if (filterName == "projectFlags") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          console.log(filter);
          this.postFilterData1_State(filter, filterName);
        } else if (filterName == "sponsoringDepartment") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData6_State(filter, filterName);
        } else if (filterName == "projectStatus") {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData7_State(filter, filterName);
        } else {
          const entries = Object.entries(filter);
          const lastEntry = entries.pop();
          delete filter[lastEntry[0]];
          filter.checked = false;
          this.postFilterData(filter, filterName);
        }
      }
    );
  };
  postFilterData = (value, filterName) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
      case "escalationLevel":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter)
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    console.log(value.checked);
    if (value.checked) {
      const newValue1 = { ...value, filterName: filterName };
      const newItems1 = [...this.state.QuickFilters];
      const newItems2 = [...this.state.StateQuickFilters];
      newItems1.push(newValue1);
      newItems2.push(newValue1);
      this.setState({ QuickFilters: newItems1, StateQuickFilters: newItems2 });
    } else {
      const targetObjectIndex = this.state.QuickFilters.findIndex(
        item => item.displayName === value.displayName
      );

      if (targetObjectIndex !== -1) {
        this.state.QuickFilters.splice(targetObjectIndex, 1);
      }
      const targetObjectIndex1 = this.state.StateQuickFilters.findIndex(
        item => item.displayName === value.displayName
      );

      if (targetObjectIndex1 !== -1) {
        this.state.StateQuickFilters.splice(targetObjectIndex1, 1);
      }
    }
    _getIssueList(
      {
        ...issueListParams,
        [filterName]: currentFilter,
        offset: 0,
        limit: 10,
        ...extraParams,
        ...{ groupCategory: this.getGroupCategory() }
      },
      removeSortFilter
    );
    // if (filterName == "projectZones") {
    //   const filteredArray = currentFilter.filter(
    //     item => typeof item === "object"
    //   );
    //   const result = filteredArray.reduce((acc, item) => {
    //     if (typeof item === "object") {
    //       acc.push(item.key);
    //     } else {
    //       acc.push(item);
    //     }
    //     return acc;
    //   }, []);
    //   const filteredArray1 = result.filter(
    //     item => !filteredArray.some(jsonObject => jsonObject.key === item)
    //   );
    //   _getIssueList(
    //     {
    //       ...issueListParams,
    //       [filterName]: value.checked == false ? filteredArray1 : result,
    //       offset: 0,
    //       limit: 10,
    //       ...extraParams,
    //       ...{ groupCategory: this.getGroupCategory() }
    //     },
    //     removeSortFilter
    //   );
    // } else {
    //   _getIssueList(
    //     {
    //       ...issueListParams,
    //       [filterName]: currentFilter,
    //       offset: 0,
    //       limit: 10,
    //       ...extraParams,
    //       ...{ groupCategory: this.getGroupCategory() }
    //     },
    //     removeSortFilter
    //   );
    // }
  };
  postFilterData1 = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter);
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ Monitoringflagcurrent: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData1_State = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter);
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ MonitoringFlag_State: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,

                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,
                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData2_State = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter);
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ RecipientDistrict_State: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,

                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,
                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData3_State = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter);
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ Recipient_State_Department: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,

                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,
                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData4_State = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter);
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ IssueStages_State: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,

                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,
                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData5_State = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter);
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ Issue_Category_State: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,

                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,
                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData6_State = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter);
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ Issue_Sponsoring_Department: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,

                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,
                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData7_State = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter);
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ ProjectStatus_State: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,

                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,
                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData8_State = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter);
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ ProjectStage_State: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,

                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatastate[0]]: this.state
                  .MonitoringFlag_State,
                [this.state.quickfilterdatastate[1]]: this.state
                  .RecipientDistrict_State,
                [this.state.quickfilterdatastate[2]]: this.state
                  .Recipient_State_Department,
                [this.state.quickfilterdatastate[3]]: this.state
                  .IssueStages_State,
                [this.state.quickfilterdatastate[4]]: this.state
                  .Issue_Category_State,
                [this.state.quickfilterdatastate[5]]: this.state
                  .Issue_Sponsoring_Department,
                [this.state.quickfilterdatastate[6]]: this.state
                  .ProjectStatus_State,
                [this.state.quickfilterdatastate[7]]: this.state
                  .ProjectStage_State,
                offset: 0,
                limit: 10,

                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData2 = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    //console.log(value);
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ RecipientStatecurrent: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                //...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData3 = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    //console.log(value);
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter)
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }

    this.setState({ RecipientMinistrycurrent: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                // ...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData4 = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    //console.log(value);
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ IssueLocationcurrent: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                //...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData5 = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    //console.log(value);
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ IssueStagescurrent: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                //...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData6 = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    //console.log(value);
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter)
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ IssueCategorycurrent: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                // ...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData7 = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    //console.log(value);
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ IssueSponsoringMinistrycurrent: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                //...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData8 = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    //console.log(value);
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter)
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ ProjectStatuscurrent: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                //...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData9 = (value, filterName, QuickFilter) => {
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;
    //console.log(value);
    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    this.setState({ ProjectStagecurrent: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                //...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  postFilterData10 = (value, filterName, QuickFilter) => {
    //console.log(value)
    //console.log(filterName)
    const {
      issueListReducer: { selectedFilters },
      _getIssueList
    } = this.props;

    let currentFilter = selectedFilters[filterName];
    let issueListParams = selectedFilters;
    let extraParams = {};
    let removeSortFilter = false;
    let val = null;
    switch (filterName) {
      // in this case value is object
      case "projectGroupBy":
      case "stages":
      case "category":
      case "subCategory":
      case "projectStatus":
      case "recipientState":
      case "recipientCenter":
      case "sponsoringState":
      case "sponsoringMinistry":
      case "sponsoringDepartment":
      case "districtStateDept":
      case "assignedToDistrictStateDept":
      case "projectStage":
      case "projectFlags":
      case "recipientDistrictStateDept":
      case "recipientStateDepartment":
      case "recipientDistrict":
      case "issueDistStateDept":
      case "proponent":
      case "bucket":
      case "milestone":
      case "bucketStatus":
      case "milestoneStatus":
      case "issueZones":
      case "centerState":
        currentFilter = currentFilter || [];
        val = currentFilter.find(val => val.key === value.key);
        //console.log(currentFilter)
        //console.log(value)
        if (Array.isArray(value)) {
          if (value.length == 0) {
            currentFilter = value;
          } else {
            value.map(item => {
              !val
                ? currentFilter.push(item)
                : (currentFilter = currentFilter.filter(
                    val => val.key !== item.key
                  ));
            });
            var set = new Set();
            var results = [];
            //currentFilter=value
            for (let list of currentFilter) {
              let id = Object.values(list).join("");
              if (!set.has(id)) {
                set.add(id);
                results.push(list);
              }
            }
            currentFilter = results;
            currentFilter = value;
          }
        } else {
          !val
            ? currentFilter.push(value)
            : (currentFilter = currentFilter.filter(
                val => val.key !== value.key
              ));
        }

        break;

      case "createdByMinistry":
        currentFilter = value.checked ? +value.key : null;
        break;

      // in this case value is string
      case "projectIdFilter":
        currentFilter = value || null;
        break;

      case "taskCompletionDate":
      case "projectCost":
      case "delayedProject":
      case "issueAgeing":
      case "costOverRun":
        currentFilter = currentFilter || [];
        const { key } = value || {};
        const from = key.split("-")[0];
        const to = key.split("-")[1];

        if (isValidArray(currentFilter)) {
          const index = currentFilter.findIndex(value => {
            const { key } = value;
            return key.split("-")[0] === from && key.split("-")[1] === to;
          });

          index < 0
            ? currentFilter.push({ ...value, key: from + "-" + to })
            : currentFilter.splice(index, 1);
        } else {
          currentFilter.push({ ...value, key: from + "-" + to });
        }
        break;

      // In this case value is boolean
      case "pmg":
      case "mom":
      case "pragatiReview":
        currentFilter = value.checked ? [value] : null;
        extraParams = { ...selectedFilters };
        !value.checked && delete extraParams[filterName];
        removeSortFilter = value.checked;
        break;

      case "search":
      case "createdDate":
        currentFilter = value;
        extraParams = { sortBy: null, sortOrder: null };
        break;

      default:
        break;
    }
    // const index = this.state.IssueZonecurrent.findIndex((item) => {
    //   return item.key === value.key && item.displayName === value.displayName && item.count === value.count;
    // });

    // // If the object is found, remove it from the array
    // if (index !== -1) {
    //   this.state.IssueZonecurrent.splice(index, 1);
    // }
    this.setState({ IssueZonecurrent: currentFilter }, () => {
      // get project list
      {
        QuickFilter == "QuickFilter"
          ? _getIssueList(
              {
                //...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            )
          : _getIssueList(
              {
                ...issueListParams,
                [this.state.quickfilterdatanew[0]]: this.state
                  .Monitoringflagcurrent,
                [this.state.quickfilterdatanew[1]]: this.state
                  .RecipientStatecurrent,
                [this.state.quickfilterdatanew[2]]: this.state
                  .RecipientMinistrycurrent,
                [this.state.quickfilterdatanew[3]]: this.state
                  .IssueLocationcurrent,
                [this.state.quickfilterdatanew[4]]: this.state
                  .IssueStagescurrent,
                [this.state.quickfilterdatanew[5]]: this.state
                  .IssueCategorycurrent,
                [this.state.quickfilterdatanew[6]]: this.state
                  .IssueSponsoringMinistrycurrent,
                [this.state.quickfilterdatanew[7]]: this.state
                  .ProjectStatuscurrent,
                [this.state.quickfilterdatanew[8]]: this.state
                  .ProjectStagecurrent,
                [this.state.quickfilterdatanew[9]]: this.state.IssueZonecurrent,
                offset: 0,
                limit: 10,
                ...extraParams,
                ...{ groupCategory: this.getGroupCategory() }
              },
              removeSortFilter
            );
      }
    });
  };
  clearAll = () => {
    this.setState(
      { dates: {}, search: "", QuickFilters: [], StateQuickFilters: [] },
      () => {
        this.props.CLEAR_ISSUE_OLD_FILTERS_ACTION(this.getGroupCategory());
      }
    );
    localStorage.setItem("ClearAll", JSON.stringify(true));
  };

  getQueryParams = () => {
    const {
      location: { search }
    } = this.props;
    const { projectId, issueId } = queryString.parse(search);
    return { projectId, issueId };
  };

  getIssueStackeHolder = async () => {
    let {
      issueListReducer: { selectedFilters }
    } = this.props;
    return await getIssueStakeHolderAction(undefined, selectedFilters);
  };

  /**     On issue list download   */

  onIssueListDownload = async () => {
    let {
      issueListReducer: { selectedFilters },
      getDownloadIssueListAction
    } = this.props;
    const { includeComments } = this.state;
    let params = { ...selectedFilters, includeComments };
    await getDownloadIssueListAction(undefined, params);
  };
  onChangeIncludeComments = () => {
    this.setState(prevState => ({
      includeComments: !prevState.includeComments
    }));
  };
  onIssueBriefDownload = async () => {
    let {
      issueListReducer: { selectedFilters },
      getDownloadIssueBriefDocAction
    } = this.props;
    await getDownloadIssueBriefDocAction(undefined, selectedFilters);
  };

  onIssueBriefPdfDownload = async () => {
    let {
      issueListReducer: { selectedFilters },
      getDownloadIssueBriefPDFAction
    } = this.props;
    await getDownloadIssueBriefPDFAction(undefined, selectedFilters);
  };

  onClearDownload = () => {
    const { clearIssueListDownloadAction } = this.props;
    clearIssueListDownloadAction();
  };

  onClearBriefDownload = () => {
    const { clearIssueBriefDownloadAction } = this.props;
    clearIssueBriefDownloadAction();
  };

  onClearPdfBriefDownload = () => {
    const { clearIssueBriefPdfDownloadAction } = this.props;
    clearIssueBriefPdfDownloadAction();
  };

  /** End of issue list download   */

  /**   for date section  */
  onDateChange = ({ createdDate, dates }) => {
    this.postFilterData(createdDate, "createdDate");
    this.setState({ dates: { createdDate }, displayDateTitle: dates });
  };

  /**   for search section  */
  onSearch = e => {
    const { value } = e.target;
    this.setState({
      search: value,
      isSearching: true
    });
  };

  onLoadAfterSearch = () => {
    const { search } = this.state;
    this.setState(
      {
        isSearching: false
      },
      () => {
        this.postFilterData(search, "search");
      }
    );
  };

  /** End for search section */

  onChangeSort = value => {
    const { sortBy, sortOrder } = value;
    const {
      props: {
        _getIssueList,
        issueListReducer: { selectedFilters }
      }
    } = this;
    _getIssueList({
      ...selectedFilters,
      sortBy,
      sortOrder,
      ...{ groupCategory: this.getGroupCategory() }
    });
  };

  callApiOnSuccess = () => {
    const {
      props: {
        _getIssueList,
        getProjectTimelineData,
        issueListReducer: { selectedFilters }
      }
    } = this;
    const { projectId } = this.getQueryParams();
    _getIssueList({
      ...selectedFilters,
      ...{ groupCategory: this.getGroupCategory() }
    });
    getProjectTimelineData(projectId);
  };
  componentDidUpdate(prevProps, prevState) {
    // ✅ clear only ONCE when projectAwardedBy turns true
    // if (
    //   this.state.projectAwardedBy &&
    //   prevState.projectAwardedBy !== this.state.projectAwardedBy
    // ) {
    //   this.setState({ StateQuickFilters: [] });
    //   return;
    // }

    const {
      issueListReducer: {
        data: issueListDTO,
        selectedFilters,
        bubbleFilters,
        isLoading
      }
    } = this.props;

    const hasReducerValuesChanged =
      prevState.isLoading !== isLoading ||
      prevState.issueListDTO !== issueListDTO;

    if (!hasReducerValuesChanged) return;

    let newFiltersData = [...prevState.QuickFilters];
    let newFiltersStateData = [...prevState.StateQuickFilters];

    bubbleFilters.forEach(item => {
      for (const [filterName, filters] of Object.entries(item)) {
        filters.forEach(filter => {
          if (!newFiltersData.some(f => f.key === filter.key)) {
            newFiltersData.push({
              key: filter.key,
              displayName: filter.displayName,
              checked: true,
              filterName
            });
          }

          if (!newFiltersStateData.some(f => f.key === filter.key)) {
            newFiltersStateData.push({
              key: filter.key,
              displayName: filter.displayName,
              checked: true,
              filterName
            });
          }
        });
      }
    });

    this.setState({
      isLoading,
      issueListDTO,
      selectedFilters,
      QuickFilters: newFiltersData.filter(f => f.key && f.displayName),
      StateQuickFilters: newFiltersStateData.filter(f => f.key && f.displayName)
    });
  }

  // onProjectAwardedByChange = e => {
  //   console.log("success");
  //   const {
  //     _getIssueList,
  //     getDashboardNotifications,
  //     getNotificationUpdates,
  //     issueListReducer: { selectedFilters }
  //   } = this.props;
  //   console.log(selectedFilters)
  //   this.setState(
  //     {
  //       projectAwardedBy: e.target.checked,
  //       QuickFilters: [],
  //       StateQuickFilters: []
  //     },
  //     () => {
  //       getDashboardNotificationsAllViewed(
  //         undefined,
  //         this.getGroupCategory()
  //       ).then(resp => {
  //         // if (resp && resp.status) getDashboardNotifications();
  //         if (resp && resp.status) {
  //           getNotificationUpdates();
  //         }
  //       });
  //       _getIssueList({
  //         ...selectedFilters,
  //         ...{
  //           groupCategory: this.getGroupCategory()
  //         }
  //       });
  //     }
  //   );
  // };

  onProjectAwardedByChange = e => {
    const isChecked = e.target.checked;

    const {
      _getIssueList,
      getNotificationUpdates,
      issueListReducer: { selectedFilters }
    } = this.props;

    const { offset = 0, limit = 10 } = selectedFilters || {};

    const updatedSelectedFilters = {
      offset,
      limit,
      groupCategory: isChecked ? "STATE" : "CENTRAL",
      projectGroupBy: [
        {
          key: "projectGroupBy",
          displayName: "Project",
          checked: true
        }
      ]
    };

    this.setState(
      {
        projectAwardedBy: isChecked,

        // ✅ update StateQuickFilters ONLY when checked
        StateQuickFilters: isChecked
          ? [
              {
                key: "projectGroupBy",
                displayName: "Project",
                checked: true,
                filterName: "projectGroupBy"
              }
            ]
          : [],

        QuickFilters: []
      },
      () => {
        getDashboardNotificationsAllViewed(
          undefined,
          this.getGroupCategory()
        ).then(resp => {
          if (resp && resp.status) {
            getNotificationUpdates();
          }
        });

        _getIssueList(updatedSelectedFilters);
      }
    );
  };

  //   onProjectAwardedByChange = e => {
  //   const isChecked = e.target.checked;

  //   const {
  //     _getIssueList,
  //     getNotificationUpdates,
  //     issueListReducer: { selectedFilters }
  //   } = this.props;

  //   // preserve only pagination
  //   const { offset = 0, limit = 10 } = selectedFilters || {};
  //   const allowedKeys = ["offset", "limit", "groupCategory", "projectGroupBy"];

  // Object.keys(selectedFilters).forEach(key => {
  //   if (!allowedKeys.includes(key)) {
  //     delete selectedFilters[key];
  //   }
  // });

  // console.log(selectedFilters,this.state.QuickFilters)
  //   // build a fresh object (no extra keys will survive)
  //   const updatedSelectedFilters = {
  //     offset,
  //     limit,
  //     groupCategory: isChecked ? "STATE" : "CENTRAL",
  //     projectGroupBy: [
  //       {
  //         key: "projectGroupBy",
  //         displayName: "Project",
  //         checked: true
  //       }
  //     ]
  //   };

  //   this.setState(
  //     {
  //       projectAwardedBy: isChecked,
  //       StateQuickFilters: [], // clears state-level quick filters
  //       QuickFilters:[]
  //     },
  //     () => {
  //       getDashboardNotificationsAllViewed(
  //         undefined,
  //         this.getGroupCategory()
  //       ).then(resp => {
  //         if (resp && resp.status) {
  //           getNotificationUpdates();
  //         }
  //       });

  //       _getIssueList(updatedSelectedFilters);
  //     }
  //   );
  // };

  //   onProjectAwardedByChange = e => {
  //     const isChecked = e.target.checked;
  // console.log(isChecked)
  //     const {
  //       _getIssueList,
  //       getNotificationUpdates,
  //       issueListReducer: { selectedFilters }
  //     } = this.props;

  //     // preserve dynamic pagination values
  //     const { offset, limit } = selectedFilters || {};
  // console.log(selectedFilters)
  //     const updatedSelectedFilters = isChecked
  //       ? {
  //           offset,
  //           limit,
  //           groupCategory: "STATE",
  //           projectGroupBy: [
  //             {
  //               key: "projectGroupBy",
  //               displayName: "Project",
  //               checked: true
  //             }
  //           ]
  //         }
  //       :
  //       {
  //           offset,
  //           limit,
  //           groupCategory: "CENTRAL",
  //           projectGroupBy: [
  //             {
  //               key: "projectGroupBy",
  //               displayName: "Project",
  //               checked: true
  //             }
  //           ]
  //         }
  //       //  {
  //       //     selectedFilters,
  //       //     groupCategory: this.getGroupCategory()
  //       //   };

  //     this.setState(
  //       {
  //         projectAwardedBy: isChecked,
  //         // QuickFilters: [],
  //          StateQuickFilters: []
  //       },
  //       () => {
  //         getDashboardNotificationsAllViewed(
  //           undefined,
  //           this.getGroupCategory()
  //         ).then(resp => {
  //           if (resp && resp.status) {
  //             getNotificationUpdates();
  //           }
  //         });

  //         _getIssueList(updatedSelectedFilters);
  //       }
  //     );
  //   };

  onProjectAwardedByChangeResponsive = type => {
    console.log("success");
    const {
      _getIssueList,
      getNotificationUpdates,
      issueListReducer: { selectedFilters }
    } = this.props;
    this.setState(
      {
        projectAwardedBy: type !== "CENTRAL",
        QuickFilters: []
        // StateQuickFilters: []
      },
      () => {
        getDashboardNotificationsAllViewed(
          undefined,
          this.getGroupCategory()
        ).then(resp => {
          if (resp && resp.status) getNotificationUpdates();
        });
        _getIssueList({
          ...selectedFilters,
          ...{
            groupCategory: this.getGroupCategory()
          }
        });
      }
    );
  };

  getGroupCategory = () => {
    return this.state.projectAwardedBy
      ? PROJECT_AWARDED_BY.STATE
      : PROJECT_AWARDED_BY.CENTRAL;
  };

  filterOpen = () => {
    let x = document.getElementsByClassName("common-list-responsive-filters");
    let y = document.getElementsByClassName("close-filter");
    if (
      x[0].classList.contains("display-none") &&
      y[0].style.display === "none"
    ) {
      x[0].classList.add("display-block");
      x[0].classList.remove("display-none");
      y[0].style.display = "block";
    } else if (x[0].classList.contains("display-block")) {
      x[0].classList.add("display-none");
      x[0].classList.remove("display-block");
    } else {
      x[0].classList.add("display-block");
      y[0].style.display = "block";
    }
  };
  filterClose = () => {
    let x = document.getElementsByClassName("common-list-responsive-filters");
    let y = document.getElementsByClassName("close-filter");
    if (
      x[0].classList.contains("display-block") &&
      y[0].style.display === "block"
    ) {
      x[0].classList.add("display-none");
      x[0].classList.remove("display-block");
      y[0].style.display = "none";
    }
  };
  renderStateQuickFilter = () => {
    this.setState({
      StateQuickFilters: [
        {
          key: "projectGroupBy",
          displayName: "Project",
          checked: true,
          filterName: "projectGroupBy"
        }
      ]
    });
  };
  renderModalIIGCreateProjectDisabled = () => {
    return (
      <>
        <ModalIIGCreateProjectDisabled
          show={() =>
            this.setState({
              showModalForCreateProjectDisabled: true
            })
          }
          handleClose={() =>
            this.setState({
              showModalForCreateProjectDisabled: false
            })
          }
        />
      </>
    );
  };

  render() {
    const {
      state: {
        search,
        isSearching,
        projectAwardedBy,
        displayDateTitle,
        StateQuickFilters
      },
      props: {
        permission,
        issueListDownload,
        issueBriefDownload,
        issueBriefPdfDownload,
        notificationData,
        notifyStatusUpdateData,
        issueListReducer: {
          data: issueListDTO,
          selectedFilters,
          bubbleFilters,
          isLoading
        }
      },
      onSearch,
      onChangeSort,
      onDateChange,
      postFilterData,
      postFilterData1,
      postFilterData2,
      postFilterData3,
      postFilterData4,
      postFilterData5,
      postFilterData6,
      postFilterData7,
      postFilterData8,
      postFilterData9,
      postFilterData10,
      postFilterData1_State,
      postFilterData2_State,
      postFilterData3_State,
      postFilterData4_State,
      postFilterData5_State,
      postFilterData6_State,
      postFilterData7_State,
      postFilterData8_State,
      onLoadAfterSearch,
      onIssueListDownload,
      getIssueStackeHolder,
      onClearDownload,
      onClearBriefDownload,
      onClearPdfBriefDownload,
      callApiOnSuccess,
      onIssueBriefDownload,
      onIssueBriefPdfDownload,
      onChangeIncludeComments
    } = this;
    // const hasReducerValuesChanged =
    //   this.state.isLoading !== isLoading ||
    //   this.state.issueListDTO !== issueListDTO;
    // // ... check other properties for changes
    // if (hasReducerValuesChanged) {
    //   const newFiltersData = [...this.state.QuickFilters];
    //   const newFiltersStateData = [...this.state.StateQuickFilters];
    //   bubbleFilters.forEach(item => {
    //     for (const [filterName, filters] of Object.entries(item)) {
    //       filters.forEach(filter => {
    //         const existingFilterIndex = newFiltersData.findIndex(
    //           f => f.key === filter.key
    //         );
    //         const existingFilterStateIndex = newFiltersStateData.findIndex(
    //           f => f.key === filter.key
    //         );
    //         if (existingFilterIndex === -1) {
    //           // Add filter only if it doesn't already exist
    //           newFiltersData.push({
    //             key: filter.key,
    //             displayName: filter.displayName,
    //             checked: true,
    //             filterName
    //           });
    //         }
    //         if (existingFilterStateIndex === -1) {
    //           // Add filter only if it doesn't already exist
    //           newFiltersStateData.push({
    //             key: filter.key,
    //             displayName: filter.displayName,
    //             checked: true,
    //             filterName
    //           });
    //         }
    //       });
    //     }
    //   });
    //   const data = newFiltersData.filter(item => {
    //     return item.key !== undefined && item.displayName !== undefined;
    //   });
    //   const state_data = newFiltersStateData.filter(item => {
    //     return item.key !== undefined && item.displayName !== undefined;
    //   });
    //   this.setState({
    //     isLoading,
    //     issueListDTO,
    //     selectedFilters,
    //     QuickFilters: data,
    //     StateQuickFilters: state_data
    //   });
    // }
    const pageCount = Math.ceil(
      get(issueListDTO, "total") / get(selectedFilters, "limit")
    );
    const userInfo = getLocalstorage("user");
    const isUserPP = userInfo.groupCategory === "PP";
    const isUserPMG = userInfo.groupCategory === "PMG";
    const groupCategory = this.getGroupCategory();

    let central, state;
    if (notifyStatusUpdateData && notifyStatusUpdateData) {
      central =
        groupCategory !== "STATE" && groupCategory !== "STATE_PMG"
          ? 0
          : notifyStatusUpdateData.central || 0;
      state =
        groupCategory === "STATE" || groupCategory === "STATE_PMG"
          ? 0
          : notifyStatusUpdateData.state || 0;
    }
    const user = getLocalstorage("user");
    console.log(this.state.StateQuickFilters);

    return (
      <React.Fragment>
        {this.state.showModalForCreateProjectDisabled === true &&
          this.renderModalIIGCreateProjectDisabled()}
        <div className="content no-sidebar listpage-wrapper">
          <div className="container">
            <div className="common-list-heading-wrapper">
              <div className="common-list-heading-left">
                <h1 className="common-list-heading-text">
                  Issue(s){" "}
                  {(get(issueListDTO, "total") && (
                    <span>({get(issueListDTO, "total")})</span>
                  )) ||
                    null}
                </h1>
                <div className="total-project-count">
                  <span>Project Count :</span>{" "}
                  {get(issueListDTO, "totalProjectCount")}
                  <span className="seperator">|</span>{" "}
                  <div>
                    <span>Project Cost :</span>
                    {get(issueListDTO, "totalCost") &&
                      formatNumberOnDashBoard(
                        get(issueListDTO, "totalCost"),
                        false
                      )}{" "}
                    Cr.
                  </div>
                </div>
              </div>
              <div className="common-list-heading-right">
                <OverlayTrigger
                  overlay={
                    <Tooltip
                      id="tooltip-pdf"
                      className={`issues-actions-tooltip ${""}`}
                    >
                      {"Preview and Download Report"}
                    </Tooltip>
                  }
                >
                  <div>
                    <DownloadExcelReport
                      isLoading={issueBriefPdfDownload.isLoading}
                      downloadLink={issueBriefPdfDownload.downloadingSrc}
                      onClearDownload={onClearPdfBriefDownload}
                      onStartDownloading={onIssueBriefPdfDownload}
                      iconClassName="pdf-icon"
                    />
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  overlay={
                    <Tooltip
                      id="tooltip-pdf"
                      className={`issues-actions-tooltip ${""}`}
                    >
                      {"Download Report"}
                    </Tooltip>
                  }
                >
                  <div>
                    <DownloadExcelReport
                      isLoading={issueBriefDownload.isLoading}
                      downloadLink={issueBriefDownload.downloadingSrc}
                      onClearDownload={onClearBriefDownload}
                      onStartDownloading={onIssueBriefDownload}
                      iconClassName="doc-icon"
                    />
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  overlay={
                    <Tooltip
                      id="tooltip-pdf"
                      className={`issues-actions-tooltip ${""}`}
                    >
                      {"Download Flat File"}
                    </Tooltip>
                  }
                >
                  <div>
                    <DownloadExcelReport
                      isLoading={issueListDownload.isLoading}
                      downloadLink={issueListDownload.downloadingSrc}
                      onClearDownload={onClearDownload}
                      onStartDownloading={onIssueListDownload}
                    />
                  </div>
                </OverlayTrigger>
                <Form.Check
                  type="checkbox"
                  label="Download with Comments"
                  className="download-check-box comments-check"
                  onChange={onChangeIncludeComments}
                />
                {this.state.projectAwardedBy !== false ||
                user.groupCategory !== "STATE_PMG" ? (
                  <DisplayByPermission
                    display={get(permission, "customNotification")}
                  >
                    <SendByComponent
                      containerClass="send_notification"
                      getStakeHolders={getIssueStackeHolder}
                      notificationCO={{
                        issueFacetsCO: transformIssueListPayload(
                          selectedFilters
                        )
                      }}
                      customNotificationType="ISSUE"
                      permission={permission}
                      projectAwardedBy={this.getGroupCategory()}
                    />
                  </DisplayByPermission>
                ) : null}
                <DisplayByPermission
                  display={
                    get(permission, "createProject") &&
                    !get(permission, "canViewOnlyProject")
                  }
                >
                  {get(issueListDTO, "draftStatus") &&
                  get(issueListDTO, "draftStatus").drafted ? (
                    <div style={{ height: "47px" }}>
                      <Link
                        to={{
                          pathname: PATHS.CREATE_PROJECT,
                          state: { draftedProject: true }
                        }}
                      >
                        <Button className="btn-orange no-padding small-height create-btn">
                          Project Draft
                        </Button>
                      </Link>
                      <p className="saved-in-draft">
                        Modified On{" "}
                        <span className="draft-on">
                          {dateFormat(
                            get(issueListDTO, "draftStatus").draftedOn
                          )}
                        </span>
                      </p>
                    </div>
                  ) : isLoading === STATUS.SUCCESS &&
                    (get(permission, "createCentralProject") ||
                      get(permission, "createStateProject")) ? (
                    <Link to={PATHS.CREATE_PROJECT}>
                      <Button
                        className="btn-orange no-padding small-height create-btn"
                        data-test="issues-tab-create-project-button"
                      >
                        Create Project
                      </Button>
                    </Link>
                  ) : (
                    <Button
                      className="btn-orange no-padding small-height create-btn"
                      onClick={() =>
                        this.setState({
                          showModalForCreateProjectDisabled: true
                        })
                      }
                    >
                      Create Project
                    </Button>
                  )}
                </DisplayByPermission>
              </div>
            </div>
            <div
              className="common-list-content-wrapper"
              style={{
                marginTop:
                  get(issueListDTO, "draftStatus") &&
                  get(issueListDTO, "draftStatus").drafted
                    ? "0.5%"
                    : null
              }}
            >
              <div className="common-list-filter-wrapper">
                <h2>Sponsored Scheme</h2>
                <ToggleBtn
                  checked={projectAwardedBy}
                  callback={this.onProjectAwardedByChange}
                  central={central}
                  state={state}
                />
                <div className="sponser-toggle-wrapper">
                  <Button
                    className={`${
                      projectAwardedBy
                        ? "toggle-sponser-btn"
                        : "selected-sponser-btn"
                    }`}
                    onClick={() =>
                      this.onProjectAwardedByChangeResponsive("CENTRAL")
                    }
                  >
                    CENTRAL
                    {central ? (
                      <span>{central > 99 ? "99+" : central}</span>
                    ) : null}
                  </Button>
                  <Button
                    className={`${
                      projectAwardedBy
                        ? "selected-sponser-btn"
                        : "toggle-sponser-btn"
                    }`}
                    onClick={() =>
                      this.onProjectAwardedByChangeResponsive("STATE")
                    }
                  >
                    STATE
                    {state ? <span>{state > 99 ? "99+" : state}</span> : null}
                  </Button>
                </div>
                <Form>
                  <div className="issue-list-filters">
                    <div className="filter-header">
                      <div className="filter-title">
                        <Image src={IconFilter} alt="Filter Icon" />
                        <span>Filters</span>
                      </div>
                      {/**  {(bubbleFilters.length > 0 && (
                          <div className="clear-filter" onClick={this.clearAll}>
                            Clear All
                          </div>
                        )) ||
                          null} */}
                      {this.state.projectAwardedBy ? (
                        <>
                          <StateIssuesQuickFilter
                            filtersValue={selectedFilters}
                            filterData={get(issueListDTO, "filters")}
                            staticFilterData={
                              this.state.staticfilterdata_for_state
                            }
                            onFilterChange={this.handleStateFilterChange}
                            checkedData={this.state.StateQuickFilters}
                            onChange1={postFilterData1_State}
                            onChange2={postFilterData2_State}
                            onChange3={postFilterData3_State}
                            onChange4={postFilterData4_State}
                            onChange5={postFilterData5_State}
                            onChange6={postFilterData6_State}
                            onChange7={postFilterData7_State}
                            onChange8={postFilterData8_State}
                          />
                        </>
                      ) : null}
                      {this.state.projectAwardedBy ? (
                        <>
                          {/* {(bubbleFilters.length > 1 && (
                            <div
                              className="clear-filter"
                              onClick={this.clearAll}
                            >
                              Clear All
                            </div>
                          )) ||
                            null} */}
                        </>
                      ) : (
                        <>
                          {/*  Quick Filter Component Call start **/}
                          <IssueQuickFilter
                            filtersValue={selectedFilters}
                            filterData={get(issueListDTO, "filters")}
                            staticFilterData={this.state.staticfilterdata}
                            onFilterChange={this.handleFilterChange}
                            checkedData={this.state.QuickFilters}
                            onChange1={postFilterData1}
                            onChange2={postFilterData2}
                            onChange3={postFilterData3}
                            onChange4={postFilterData4}
                            onChange5={postFilterData5}
                            onChange6={postFilterData6}
                            onChange7={postFilterData7}
                            onChange8={postFilterData8}
                            onChange9={postFilterData9}
                            onChange10={postFilterData10}
                          />
                          {/*  Quick Filter Component Call End **/}
                        </>
                      )}
                    </div>

                    {isLoading === STATUS.LOADING ? (
                      <LoaderTemplate
                        parentClass={"filter-loader-project-list"}
                        children={<FilterLoader />}
                        height={300}
                        width={400}
                      />
                    ) : (
                      <React.Fragment>
                        <FilterComponent
                          filtersValue={selectedFilters}
                          filterData={get(issueListDTO, "filters")}
                          onChange={postFilterData}
                          projectCategory={this.getGroupCategory()}
                        />
                      </React.Fragment>
                    )}
                  </div>
                </Form>
                <Form>
                  <div className="common-list-responsive-filters">
                    <div className="common-filter-header">
                      <div className="common-filter-title">
                        <span>Filters</span>
                      </div>
                      {/**  {(bubbleFilters.length > 0 && (
                          <div className="clear-filter" onClick={this.clearAll}>
                            CLEAR ALL
                          </div>
                        )) ||
                          null} */}
                    </div>

                    {isLoading === STATUS.LOADING ? (
                      <LoaderTemplate
                        parentClass={"filter-loader-project-list"}
                        children={<FilterLoader />}
                        height={90}
                      />
                    ) : (
                      <React.Fragment>
                        <ResponsiveFilter
                          filtersValue={selectedFilters}
                          filterData={get(issueListDTO, "filters")}
                          onChange={postFilterData}
                        />
                      </React.Fragment>
                    )}

                    <div className="common-filter-actions-wrapper">
                      <div onClick={this.filterClose}>Close</div>
                    </div>
                  </div>
                </Form>
                <div className="close-filter" onClick={this.filterClose} />
              </div>
              <div className="common-list-multiple">
                <div className="common-list-exposed-filters">
                  <div className="filters-sections calender-filter-section">
                    <CalendarFilter
                      onChange={onDateChange}
                      calenderOptions={OTHER_CALENDER}
                      displayDateTitle={displayDateTitle}
                    />
                  </div>
                  <div className="filters-sections">
                    <Search
                      value={search}
                      isLoading={isSearching}
                      onChange={onSearch}
                      callAfterDebounce={onLoadAfterSearch}
                      placeholder="Search"
                    />
                  </div>
                  <div className="filters-sections sort-filter-wrapper">
                    <SortBy
                      sortBy={SORT_BY_ISSUE_FILTER_LIST}
                      onChangeSort={onChangeSort}
                    />
                    <button className="filter-btn" onClick={this.filterOpen}>
                      <Image src={FilterIcon} alt="Filter Icon" />
                      Filters
                    </button>
                  </div>
                </div>

                {this.state.projectAwardedBy ? (
                  <>
                    <div className="applied-filter-list">
                      {this.state.StateQuickFilters.length == 0 ? null : (
                        <>
                          {this.state.StateQuickFilters.map(
                            (element, index) => (
                              <div className="applied-filter" key={index}>
                                {element.displayName ===
                                "PHYSICALLY_COMPLETED" ? (
                                  <>PHYSICALLY COMPLETED/CC UNDER ISSUE</>
                                ) : (
                                  <>{element.displayName}</>
                                )}
                                <span
                                  className="close"
                                  onClick={e => {
                                    this.handleStateCheckbox(
                                      element,
                                      element.filterName
                                    );
                                  }}
                                >
                                  X
                                </span>
                              </div>
                            )
                          )}
                        </>
                      )}

                      {/**New Code For Clear All Functionality Start */}
                      {this.state.StateQuickFilters.length > 1 ? (
                        <div
                          className="clear-filter-new"
                          onClick={this.clearAll}
                        >
                          Clear All
                        </div>
                      ) : null}
                      {/**New Code For Clear All Functionality End */}
                    </div>
                    {/**For State Section Starts */}
                    {/* <div className="applied-filter-list">
                      {bubbleFilters.map((item, index) => {
                        const filterKey = Object.keys(item)[0];
                        const filterValue = item[filterKey];
                        return Array.isArray(item[filterKey]) ? (
                          item[filterKey].map(val => {
                            return (
                              <div className="applied-filter" key={index}>
                                {val.displayName}
                                <span
                                  className="close"
                                  onClick={e => {
                                    postFilterData(val, filterKey);
                                  }}
                                >
                                  X
                                </span>
                              </div>
                            );
                          })
                        ) : (
                          <div className="applied-filter" key={index}>
                            {filterValue[0]
                              ? `${filterValue[0].displayName}`
                              : ""}
                            <span
                              className="close"
                              onClick={e => {
                                filterValue[0].checked = false;
                                postFilterData(filterValue[0], filterKey);
                              }}
                            >
                              X
                            </span>
                          </div>
                        );
                      })}
                    </div> */}
                    {/**For State Section End */}
                  </>
                ) : (
                  <>
                    {/**For Central Section Starts */}
                    <div className="applied-filter-list">
                      {this.state.QuickFilters.length == 0 ? null : (
                        <>
                          {this.state.QuickFilters.map((element, index) => (
                            <div className="applied-filter" key={index}>
                              {element.displayName ===
                              "PHYSICALLY_COMPLETED" ? (
                                <>PHYSICALLY COMPLETED/CC UNDER ISSUE</>
                              ) : (
                                <>{element.displayName}</>
                              )}
                              <span
                                className="close"
                                onClick={e => {
                                  this.handleCheckbox1(
                                    element,
                                    element.filterName
                                  );
                                }}
                              >
                                X
                              </span>
                            </div>
                          ))}
                        </>
                      )}

                      {/**New Code For Clear All Functionality Start */}
                      {this.state.QuickFilters.length > 1 ? (
                        <div
                          className="clear-filter-new"
                          onClick={this.clearAll}
                        >
                          Clear All
                        </div>
                      ) : null}
                      {/**New Code For Clear All Functionality End */}
                    </div>
                    {/**For Central Section Ends */}
                  </>
                )}
                {get(issueListDTO, "listDTO") &&
                (selectedFilters && selectedFilters.offset > 0) ? (
                  <div className="add-space">
                    <Pagination
                      offset={selectedFilters.offset}
                      pageCount={
                        get(issueListDTO, "total", 0) /
                        get(issueListDTO, "limit", 0)
                      }
                      onPageChange={this.onPageChange}
                    />
                  </div>
                ) : null}
                <IssueListWitLoader
                  issueList={get(issueListDTO, "listDTO")}
                  isLoading={isLoading}
                  permission={permission}
                  callApiOnSuccess={callApiOnSuccess}
                  isIssueList={true}
                />
                {get(issueListDTO, "listDTO") ? (
                  <Pagination
                    offset={selectedFilters.offset}
                    pageCount={
                      get(issueListDTO, "total", 0) /
                      get(issueListDTO, "limit", 0)
                    }
                    onPageChange={this.onPageChange}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const {
    issueListStatus: issueListApiStatus,
    createProjectReducer: { isLoading },
    commonReducer: { status },
    donwloadExcelReducer: {
      issueListDownload,
      issueBriefDownload,
      issueBriefPdfDownload
    },
    dashboardReducer: { notificationData, notifyStatusUpdateData },
    issueListReducer
  } = state;
  return {
    status,
    isLoading,
    issueListApiStatus,
    issueListDownload,
    issueListReducer,
    notificationData,
    notifyStatusUpdateData,
    issueBriefDownload,
    issueBriefPdfDownload
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDownloadIssueListAction,
      getDownloadIssueBriefDocAction,
      getDownloadIssueBriefPDFAction,
      clearIssueListDownloadAction,
      clearIssueBriefDownloadAction,
      clearIssueBriefPdfDownloadAction,
      CLEAR_ISSUE_OLD_FILTERS_ACTION,
      _getIssueList,
      getDashboardNotifications,
      getProjectTimelineData,
      getNotificationUpdates
    },
    dispatch
  );
}

export default PermissionHOC(
  IssueListHoc(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(IssueList)
  )
);
